import TeamDetailModal from './types/team-detail/index';
import IndividualDetailModal from './types/individual-detail/index';
import { DeletePhotoModal, DeleteAccountModal } from './types/delete/index';
import RulesModal from './types/rules/index';

export { TeamDetailModal, IndividualDetailModal, DeletePhotoModal, DeleteAccountModal, RulesModal };



// WEBPACK FOOTER //
// ./src/components/general/modal/_modals.jsx